import { render, staticRenderFns } from "./BasicInfoDetailCard.vue?vue&type=template&id=1c148480"
import script from "./BasicInfoDetailCard.vue?vue&type=script&lang=js"
export * from "./BasicInfoDetailCard.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoDetailCard.vue?vue&type=style&index=0&id=1c148480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports